import {
	ContainerGutter,
	TokenTextAppearance,
	TokenTextColor,
	TextAlignment,
	Container,
	Text,
	styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { huchaLinesColor } from '../../../../../../../../helpers/color-tokens';

const MainContainer = styled(Container)`
	padding: 0px;

	/* Desktop */
	@media (min-width: 960px) {
		padding-right: var(--size-dynamic0100);
	}
`;

const StyledC2Wrapper = styled(Container)`
	border-top: 2px solid ${huchaLinesColor};
	border-bottom: 2px solid ${huchaLinesColor};
	align-content: center;
	padding-left: 4px;
	padding-right: 4px;

	margin-left: auto;
	margin-right: auto;
	height: 180px;

	@media (max-width: 959px) {
		height: 80px;
	}

	/* padding top and bottom depends on the fixed height */
`;

export const PopupHuchaStandardCardC2 = () => {
	return (
		<MainContainer stretchContent data-testid="popup-c2-container">
			<StyledC2Wrapper
				data-testid="c2-inner-container"
				stretchContent
				wrap="always"
				verticalAlign="center"
				horizontalAlign="center"
				gutter={ContainerGutter.dynamic0020}
			>
				<Text
					appearance={TokenTextAppearance.headline200}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.center}
				>
					Cada mes, acumulas 10€ para tu próximo Volkswagen.
				</Text>
			</StyledC2Wrapper>
		</MainContainer>
	);
};
